// cookie for keeping app language for user
export default 'AppLang';

